import React from 'react';

export default function Logo({ height = 36, dark = false }) {
  const fg = dark ? '#FAFAFA' : '#0A0A0A';
  return (
    <svg
      viewBox="0 0 140 64"
      style={{ height, width: 'auto', display: 'block' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <text x="0" y="22" fontFamily="Instrument Serif, serif" fontStyle="italic" fontSize="22" fill={fg}>the</text>
      <text x="0" y="58" fontFamily="Inter, sans-serif" fontWeight="700" fontSize="44" letterSpacing="-1.5" fill={fg}>UNC</text>
      <circle cx="93" cy="55" r="5" fill="#FF4D00" />
    </svg>
  );
}
